import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import * as echarts from "echarts";
import { getGuanqiaLostData } from '@/api/data';
import serverList from "../../../components/serverList/serverOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
export default {
  components: {
    serverList: serverList,
    DataOptions: DataOptions
  },
  data: function data() {
    return {
      dataList: [],
      serverInfo: [],
      dateInfo: [this.$moment().subtract(0, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        title: "关卡",
        field: "guanqia_no"
      }]
    };
  },
  methods: {
    onSearchBtn: function onSearchBtn() {
      var _this = this;
      var searchInfo = {
        sdate: this.dateInfo[0],
        edate: this.dateInfo[1],
        server_id: this.serverInfo
      };
      searchInfo.server_id = this.serverInfo;
      var _iterator = _createForOfIteratorHelper(searchInfo.server_id),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var serverId = _step.value;
          if (serverId == '0') {
            searchInfo.server_id = [];
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      getGuanqiaLostData(searchInfo).then(function (res) {
        _this.dataList = res.data.list;
        _this.updateChart(res.data.chart);
      });
    },
    updateChart: function updateChart(ary) {
      var chart = echarts.init(this.$refs.winRatioChart);
      var dateAry = [];
      var todayAry = [];
      var yesterdayAry = [];
      var lastWeekAry = [];
      var guanqiaAry = [];
      var _iterator2 = _createForOfIteratorHelper(ary),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          dateAry.push("".concat(item['date_name'], "\uFF08").concat(item['date_str'], "\uFF09"));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var option = {
        xAxis: {
          type: 'category',
          data: guanqiaAry
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: dateAry
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: dateAry[0],
          data: todayAry,
          type: 'line'
        }, {
          name: dateAry[1],
          data: yesterdayAry,
          type: 'line'
        }, {
          name: dateAry[2],
          data: lastWeekAry,
          type: 'line'
        }]
      };
      var _iterator3 = _createForOfIteratorHelper(ary[0]['list']),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item = _step3.value;
          guanqiaAry.push("\u5173\u5361".concat(_item['guanqia_no']));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      ary[0].list.forEach(function (element) {
        todayAry.push(element.start_ratio);
      });
      ary[1].list.forEach(function (element) {
        yesterdayAry.push(element.start_ratio);
      });
      ary[2].list.forEach(function (element) {
        lastWeekAry.push(element.start_ratio);
      });
      chart.setOption(option);
    }
  },
  mounted: function mounted() {
    this.onSearchBtn();
  }
};